import * as React from 'react';
import { flow } from 'lodash';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import LoadingButton from '@mui/lab/LoadingButton';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

import messagesSchema from '@giro/shared-constants/messagesSchema.constant';

import FieldPhoneComponent from '@giro/shared-components/Fields/FieldPhone.component';

import useDialogHook from '@giro-pdv/hooks/useDialogRedux.hook';

import FieldLabelFormikComponent from '@giro-pdv/components/FieldLabelFormik.component';
import TextFieldLabelComponent from '@giro-pdv/components/TextFieldLabel.component';
import format from 'date-fns/format';

import dialogSendPayment from '../store/dialogs/dialogDetailsSlips';
import postDispatchService from '@giro/shared-services/reports/getApiPdvSlipDetailsReports.service';
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from '@mui/material';

const renderTableCell = (el, idx, row) => {
  const isDate = ['created_at', 'due_date'];
  const isAmount = ['amount'];
  const isCustom = ['receipt'];

  if (isCustom.includes(el)) {
    if (el === 'receipt') {
      //return (
      //  <TableCell component="th" scope="row" key={`${el}-${idx}`}>
      //    <Button
      //      variant="contained"
      //      color="primary"
      //      size="small"
      //      sx={{ height: 32, width: 32, alignSelf: 'flex-end' }}
      //      onClick={() => dispatchRedux.receiptOpen(row.CdTransacao)}
      //      disabled={row.Status !== 'Aprovada'}
      //    >
      //      <svg
      //        width="16"
      //        height="16"
      //        fill="none"
      //        stroke="currentColor"
      //        strokeWidth="2"
      //        strokeLinecap="round"
      //        strokeLinejoin="round"
      //      >
      //        <use href="/feather-sprite.svg#printer" />
      //      </svg>
      //    </Button>
      //  </TableCell>
      //);
    }
    if (el === 'Receptor') {
      <TableCell component="th" scope="row" key={`${el}-${idx}`}>
        <Typography variant="trasso_body_extra_small" color="trasso.purple.100">
          {row[el]}
        </Typography>
      </TableCell>;
    }
  }

  if (isDate.includes(el)) {
    return (
      <TableCell component="th" scope="row" key={`${el}-${idx}`}>
        <Typography variant="trasso_body_extra_small" color="trasso.purple.100">
          {format(new Date(row[el].replace('Z', '')), 'dd/MM/yyyy')}
        </Typography>
      </TableCell>
    );
  }

  if (isAmount.includes(el)) {
    return (
      <TableCell component="th" scope="row" key={`${el}-${idx}`}>
        <Typography variant="trasso_body_extra_small" color="trasso.purple.100">
          {Number(row[el]).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </Typography>
      </TableCell>
    );
  }

  return (
    <TableCell component="th" scope="row" key={`${el}-${idx}`}>
      <Typography variant="trasso_body_extra_small" color="trasso.purple.100">
        {row[el]}
      </Typography>
    </TableCell>
  );
};

function Row(props: { row: any }) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  return (
    <React.Fragment>
      <TableRow
        key={row.DtTransacao}
        sx={{
          cursor: 'pointer',
          backgroundColor: 'white',
          '&:last-child td, &:last-child th': {
            border: 0,
          },

          '&:hover': {
            backgroundColor: 'grey.300',
          },
        }}
      >
        {[
          'created_at',
          'amount',
          'due_date',
          'payer_name',
          'status',
          'receipt',
        ].map((el, idx) => renderTableCell(el, idx, row))}
      </TableRow>
    </React.Fragment>
  );
}

export default function DialogSendPaymentComponent() {
  const [data, setData]: any = React.useState([]);
  const dispatch = useDispatch();

  const dispatchRedux = {
    servicePost: flow(dialogSendPayment.action.servicePost, dispatch),
  };

  const selectorRedux = {
    data: useSelector(dialogSendPayment.selector.selectPayload),
    loading: useSelector(dialogSendPayment.selector.selectLoading),
  };

  const { handleClose, visible } = useDialogHook(dialogSendPayment);

  const schema = Yup.object({
    type: Yup.string().required(messagesSchema.REQUIRED).default('email'),
    destination: Yup.string()
      .when('type', {
        is: 'email',
        then: Yup.string()
          .email(messagesSchema.EMAIL)
          .required(messagesSchema.REQUIRED),
      })
      .when('type', {
        is: 'whatsapp',
        then: Yup.string()
          .required(messagesSchema.REQUIRED)
          .min(11, messagesSchema.MIN),
      }),
  });

  React.useEffect(() => {
    if (visible) {
      const fetchData = async () => {
        const [success, data] = await postDispatchService({
          date: selectorRedux.data?.split(',')[0],
        });
        setData(data);
      };
      fetchData();
    }
  }, [selectorRedux.data]);

  return (
    <Dialog open={visible} onClose={handleClose} fullWidth={true} maxWidth="md">
      <Box p={2}>
        <TableContainer>
          <Table
            aria-label="simple table"
            sx={{ minWidth: { xl: '100%', md: '1300px' } }}
            size="small"
          >
            <TableHead>
              <TableRow>
                {['Data', 'Valor', 'Vencimento', 'Pagador', 'Status', ''].map(
                  (el, idx) => (
                    <TableCell key={`row-${idx}`}>
                      <Typography
                        variant="trasso_heading_extra_small"
                        color="trasso.purple.100"
                      >
                        {el}
                      </Typography>
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row) => (
                <Row row={row} key={row.CdTransacao}></Row>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Dialog>
  );
}
